import { css } from '@emotion/react';

export const useStyles = (props) => ({
    modal: css({
        backgroundColor: "rgba(0, 82, 127, 0.70)",
        margin: 0,
        zIndex: 9999999,
        boxShadow: "0 20px 30px rgba(0, 0, 0, 0.2)",
        position: "absolute",
        left: "0",
        top: "0",
        boxSizing: "border-box",
        textAlign: "center",
    }),
    whiteBox: css({
        background: "rgb(255, 255, 255)",
        borderRadius: "0px",
        boxShadow: "0px 2px 34px 0px rgba(0, 0, 0, 0.23)",
        height: "83px",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        margin: "150px auto 0 auto",
        width: "90% !important"
    }),
    whiteBoxContent: css({
        color: "rgb(76, 81, 91)",
        fontSize: "16px"
    }),
});
